var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGnbIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.55,35.51l-8.79-8.79c2.04-2.7,3.26-6.04,3.26-9.67c0-8.87-7.22-16.09-16.09-16.09S0.84,8.17,0.84,17.05 s7.22,16.09,16.09,16.09c3.75,0,7.2-1.3,9.94-3.46l8.75,8.76c0.4,0.4,0.93,0.61,1.46,0.61c0.53,0,1.06-0.2,1.46-0.61 C39.36,37.63,39.36,36.32,38.55,35.51z M4.98,17.05c0-6.59,5.36-11.96,11.96-11.96s11.96,5.36,11.96,11.96S23.53,29,16.93,29 S4.98,23.64,4.98,17.05z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbIcon1);
export default __webpack_public_path__ + "static/media/gnb_icon_1.9c49ba9a97819d4f68e65ebc934a668a.svg";
export { ForwardRef as ReactComponent };